export default __webpack_public_path__ + "static/media/noImage.2d78d49e.png";